import { Injectable } from '@angular/core';
import { CommonAamvaModel } from '../models/common-aamva.model';
import { IncidentServiceBase } from '../services/incident-base.service';

@Injectable()
export class CommonAamvaIncidentService extends IncidentServiceBase<CommonAamvaModel> {
    constructor() {
        super('CommonAamva', () => new CommonAamvaModel());
    }
}
